import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import PhoneLink from "@/components/PhoneLink";
import logo from "@/assets/logo.png";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden text-foreground" style={{
      background: `linear-gradient(180deg, hsl(270 60% 95%) 0%, hsl(210 40% 98%) 30%, hsl(270 50% 94%) 70%, hsl(210 40% 97%) 100%)`
    }}>
      {/* Gradient orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full opacity-15 blur-3xl" style={{
        background: `radial-gradient(circle, hsl(270 70% 55%), transparent 70%)`
      }} />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full opacity-10 blur-3xl" style={{
        background: `radial-gradient(circle, hsl(270 60% 60%), transparent 70%)`
      }} />

      {/* Agent CTA */}
      {/* Join Our Agency CTA hidden until mybookofbiz CRM is ready */}

      <div className="container py-12 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Mom & Pop Insurance Shop" className="h-28 w-auto" width="112" height="112" />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Arizona's independent choice for business & family insurance. Compare 30+ carriers with a local broker who knows your community.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <PhoneLink location="footer" className="text-muted-foreground hover:text-foreground" />
              <a href="mailto:info@momandpopinsurance.com" className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
                <Mail className="w-4 h-4 shrink-0" /> info@momandpopinsurance.com
              </a>
              <span className="flex items-center gap-2 text-muted-foreground">
                <MapPin className="w-4 h-4 shrink-0" /> Phoenix, AZ 85001
              </span>
            </div>
          </div>

          {/* Insurance */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Insurance</h4>
            <ul className="space-y-2 text-sm">
              {["Auto Insurance", "Homeowners Insurance", "Commercial Insurance", "Health Insurance", "Life Insurance", "Group Benefits"].map((s) => (
                <li key={s}>
                  <Link to={`/services/${s.toLowerCase().replace(/ /g, "-")}`} className="text-muted-foreground hover:text-foreground transition-colors">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Company</h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: "About Us", href: "/about" },
                { label: "Our Team", href: "/about" },
                { label: "Blog", href: "/blog" },
                // { label: "Careers", href: "/join" }, // Hidden until mybookofbiz CRM is ready
                { label: "Contact", href: "/contact" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-muted-foreground hover:text-foreground transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Arizona Cities</h4>
            <ul className="space-y-2 text-sm">
              {["Phoenix", "Scottsdale", "Mesa", "Tempe", "Chandler", "Gilbert"].map((city) => (
                <li key={city}>
                  <Link to={`/az/${city.toLowerCase()}`} className="text-muted-foreground hover:text-foreground transition-colors">
                    {city} Insurance
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/cities" className="text-primary hover:text-primary/80 transition-colors font-medium">
                  View All 100+ Cities →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Mom & Pop Insurance Shop. Licensed in AZ, TX, NC, IL, AR, CA.</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
